const checkExists = <T>(x: T | undefined | null): x is T => !!x

export default checkExists
